import {Images} from "../../Images/Images";
import "./header.css";
import {Link, useNavigate} from "react-router-dom";
import {useMemo, useRef, useState, useEffect, useCallback} from "react";
import {IMAGE_URL} from "../../URL";
import {SET_SEARCH_BOARDS} from "../../store/constants";
import {useDispatch, useSelector} from "react-redux";
import {CiSearch} from "react-icons/ci";
import {debounce} from "lodash";
import {SearchBoardAPI} from "../../store/api/get/Board/Board";
import {
    SET_IS_EDIT,
    SET_SELECT_IMAGE,
    SET_SHOW_FORM,
    SET_TITLE
} from "../../store/reducers/BoardCreate/constants";
import {BoardsCreate} from "../WorkSpace/BoardsCreate";
import {User} from "../User/User";
import {ProfileSettings} from "./ProfileSettings";

export const Header = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const user = useSelector((state) => state.user.user);
    const searchBoards = useSelector((state) => state.boards.searchBoards) || [];
    console.log(user);
    const [isOpenProfileModal, setIsOpenProfileModal] = useState(false);
    const [isOpenSearch, setIsOpenSearch] = useState(false);
    const [inputValue, setInputValue] = useState("");

    const searchRef = useRef(null);

    const openProfileModal = () => {
        setIsOpenProfileModal(true);
    };
    const runSearch = useCallback(
        (query) => {
            if (!user?.id) return;
            dispatch(SearchBoardAPI(user.id, query));
        },
        [dispatch, user?.id]
    );

    const debouncedSearch = useMemo(
        () => debounce((query) => runSearch(query), 500),
        [runSearch]
    );

    useEffect(() => {
        return () => debouncedSearch.cancel();
    }, [debouncedSearch]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setIsOpenSearch(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === "Escape") {
                setIsOpenSearch(false);
                setIsOpenProfileModal(false);
            }
        };

        document.addEventListener("keydown", handleEscape);
        return () => document.removeEventListener("keydown", handleEscape);
    }, []);

    const handleSearchFocus = () => {
        setIsOpenSearch(true);

        if (user?.id) {
            runSearch(inputValue.trim());
        }
    };

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        setIsOpenSearch(true);

        if (!value.trim()) {
            debouncedSearch.cancel();
            dispatch({
                type: SET_SEARCH_BOARDS,
                payload: [],
            });
            return;
        }

        debouncedSearch(value.trim());
    };

    const handleBoardClick = (boardId) => {
        navigate(`/board/${boardId}`);
        setIsOpenSearch(false);
        setInputValue("");

        dispatch({
            type: SET_SEARCH_BOARDS,
            payload: [],
        });
    };

    const handleOpenCreate = () => {
        dispatch({type: SET_IS_EDIT, payload: false});
        dispatch({type: SET_TITLE, payload: ""});
        dispatch({type: SET_SELECT_IMAGE, payload: null});
        dispatch({type: SET_SHOW_FORM, payload: true});
    };

    const boardsToShow = searchBoards;
    const dropdownTitle = inputValue.trim() ? "SEARCH RESULTS" : "RECENT BOARDS";

    return (
        <header className="header">
            <Link to="/" className="header__logo">
                <img src={Images.logo} alt="logo"/>
            </Link>

            <div className="header__searchWrapper" ref={searchRef}>
                <form className="header__search" onSubmit={(e) => e.preventDefault()}>
                    <div className="header__searchBox">
                        <span className="header__searchIcon">
                            <CiSearch/>
                        </span>

                        <input
                            type="text"
                            placeholder="Search Trello"
                            value={inputValue}
                            onFocus={handleSearchFocus}
                            onChange={handleSearchChange}
                        />
                    </div>

                    <button
                        type="button"
                        className="header__createBtn"
                        onClick={handleOpenCreate}
                    >
                        Create
                    </button>
                </form>

                {isOpenSearch && (
                    <div className="searchDropdown">
                        <div className="searchDropdown__content">
                            <h4 className="searchDropdown__title">{dropdownTitle}</h4>

                            <div className="searchDropdown__list">
                                {boardsToShow.length > 0 ? (
                                    boardsToShow.map((board) => {
                                        const imageSrc =
                                            board.image ||
                                            (board.path
                                                ? `${IMAGE_URL}/media/${board.path}`
                                                : "");

                                        return (
                                            <div
                                                key={board.id}
                                                className="searchDropdown__item"
                                                onClick={() => handleBoardClick(board.id)}
                                            >
                                                {imageSrc ? (
                                                    <div
                                                        className="searchDropdown__thumb"
                                                        style={{
                                                            backgroundImage: `url(${imageSrc})`,
                                                            backgroundSize: "cover",
                                                            backgroundPosition: "center",
                                                        }}
                                                    />
                                                ) : (
                                                    <div
                                                        className="searchDropdown__thumb searchDropdown__thumb--color"
                                                        style={{
                                                            background: board.color || "#6b7280",
                                                        }}
                                                    />
                                                )}

                                                <div className="searchDropdown__info">
                                                    <p className="searchDropdown__name">
                                                        {board.name}
                                                    </p>
                                                    <span className="searchDropdown__workspace">
                                                        {board.workspace}
                                                    </span>
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className="searchDropdown__empty">
                                        Nothing found
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className="header__profile">
                <div
                    className="header__profile-logo"
                    onClick={openProfileModal}
                >
                    <User user={user} className="headerUserAvatar"/>
                </div>
            </div>

            {isOpenProfileModal && (
                <ProfileSettings isOpenProfileModal={isOpenProfileModal} setIsOpenProfileModal={setIsOpenProfileModal}/>
            )}

            <BoardsCreate is_header={true}/>
        </header>
    );
};